<template>
  <b-card>
    <b-row>
      <b-col cols="6">
        <b-form-group
            id="idInput"
            :label-cols="2"
            breakpoint="md"
            :label="$t('ID')"
            label-for="idInput">
          <b-form-input
              id="idInṕut"
              v-model="product.id"
              :disabled="true">
          </b-form-input>
        </b-form-group>
        <b-form-group v-if="isCataloger"
          id="sellerInput"
          :label-cols="2"
          breakpoint="md"
          :label="$t('Seller')"
          :invalid-feedback="!state.seller ? $t('Seleccione un seller') : ''"
          :state="product.seller.length > 0"
          label-for="marcaFormatterHelp">
          <autocomplete
            :v-if="product.seller"
            id="inputSeller"
            class="input_class optional"
            name="inputSeller"
            :maxElements="1"
            :placeholder="$t('Ingrese una seller...')"
            :provider="getSearchSeller"
            :disabled="editionDisabled"
            v-model="product.seller">
          </autocomplete>
        </b-form-group>
      </b-col>
  
      <b-col cols="6">
        <b-form-group
          id="nombreInput"
          :label-cols="2"
          breakpoint="md"
          :label="$t('Nombre')"
          :description="$t('Máximo 100 caracteres')"
          :invalid-feedback="!state.name ? $t('El nombre no es válido') : ''"
          :state="state.name"
          label-for="nombreFormatterHelp">
          <b-form-input
            id="nombreFormatterHelp"
            v-model="product.name"
            :disabled="editionDisabled"
            maxlength="100">
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6">
        <b-form-group
          id="categoriaInput"
          :label-cols="2"
          breakpoint="md"
          :label="$t('Categoría')"
          :invalid-feedback="!state.category ? $t('Seleccione una categoría') : ''"
          :state="state.category"
          label-for="categoryFormatterHelp">
          <category-tree
            :editable="!editionDisabled"
            id='categoryFormatterHelp'
            :categorySelected="product.category"
            @onCategorySelected="selectCategory">
          </category-tree>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group id="marcaInput"
          :label-cols="2"
          breakpoint="md"
          :label="$t('Marca')"
          :invalid-feedback="!state.brand ? $t('Seleccione una marca') : ''"
          :state="product.brand.length > 0"
          label-for="marcaFormatterHelp">
          <autocomplete
            :v-if="product.brand"
            id="inputBrand"
            class="input_class optional"
            name="inputBrand"
            :maxElements="1"
            :placeholder="$t('Ingrese una marca...')"
            :provider="getSearchBrands"
            :disabled="editionDisabled"
            v-model="product.brand">
          </autocomplete>
        </b-form-group>
      </b-col>
    </b-row>
  
    <b-row>
      <b-col cols="6">
        <b-form-group
          :label-cols="2"
          breakpoint="md"
          :label="$t('División')"
          label-for="division"
          :invalid-feedback="!state.division ? $t('Seleccione una division') : ''"
          :state="product.division.length > 0"
        >
          <autocomplete
            id="division"
            name="division"
            :maxElements="1"
            :provider="_searchDivisions"
            v-model="product.division"
            @input="selectedDivision"
            >
          </autocomplete>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group
          :label-cols="2"
          breakpoint="md"
          :label="$t('Departamento')"
          label-for="departament"
          :invalid-feedback="!state.department ? $t('Seleccione un departamento') : ''"
          :state="product.department.length > 0"
        >
          <autocomplete
            id="departament"
            name="departament"
            :maxElements="1"
            :disabled="!product.division || !product.division[0]"
            :provider="_searchDepartaments"
            :findOnMounted="false"
            v-model="product.department"
            @input="selectedDepartament"
            ref="departamentRef">
          </autocomplete>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6">
        <b-form-group
          :label-cols="2"
          breakpoint="md"
          :label="$t('Clase')"
          label-for="class"
          :invalid-feedback="!state.department ? $t('Seleccione una clase') : ''"
          :state="product.department.length > 0"
        >
          <autocomplete
            id="class"
            name="class"
            :maxElements="1"
            :disabled="!product.department || !product.department[0]"
            :provider="_searchClasses"
            :findOnMounted="false"
            v-model="product.clase"
            @input="selectedClass"
            ref="classRef">
          </autocomplete>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group
          :label-cols="2"
          breakpoint="md"
          :label="$t('Subclase')"
          label-for="subclass"
          :invalid-feedback="!state.subClass ? $t('Seleccione un subclase') : ''"
          :state="product.subClass.length > 0"
        >
          <autocomplete
            id="subclass"
            name="subclass"
            :maxElements="1"
            :disabled="!product.clase || !product.clase[0]"
            :provider="_searchSubClasses"
            :findOnMounted="false"
            v-model="product.subClass"
            ref="subClassRef"
            >
          </autocomplete>
        </b-form-group>
      </b-col>
    </b-row>
  
    <b-row>
      <b-col>
        <b-form-group
          id="textLinkInput"
          :label-cols="2"
          breakpoint="md"
          :label="$t('Descripción')"
          :invalid-feedback="!state.description ? $t('La descripción no es un texto / html válido') : ''"
          :state="state.description"
          label-for="textlinkFormatterHelp">
          <vue-editor :editorToolbar="customToolbar" :disabled="editionDisabled" name="Description" v-model="product.description" />
        </b-form-group>
      </b-col>
    </b-row>
  </b-card>
  </template>
  
  <script>
  import CategoryTree from './CategoryTree'
  import autocomplete from '@/components/common/vue-autocomplete'
  import { VueEditor } from 'vue2-editor'
  
  import appConfig from '@/config/applicationConfig.js'
  import { ProductServiceMixim, PRODUCT_STATES } from '@/mixims/ProductServiceMixim'
  import { OrganizationService } from '@/mixims/AdminServiceMixin'
  import {ValidationsMixim} from '@/mixims/ValidationsMixim.js'
  
  export default {
    mixins: [ProductServiceMixim, OrganizationService, ValidationsMixim],
    components: {
      CategoryTree,
      autocomplete,
      VueEditor
    },
    props: {
      product: Object,
      state: Object,
      isCataloger: {
        type: Boolean,
        default: false
      },
    },
    data () {
      return {
        isAdmin: this.$store.getters.isAdmin,
        specifications: [],
        customToolbar: [
          [{ font: [] }],
          [{ header: [false, 1, 2, 3, 4, 5, 6] }],
          [{ size: ['small', false, 'large', 'huge'] }],
          ['bold', 'italic', 'underline'],
          [
            { list: 'ordered' },
            { list: 'bullet' }
          ],
          [
            { align: '' },
            { align: 'center' },
            { align: 'right' },
            { align: 'justify' }
          ],
          ['link'],
          [{ color: [] }, { background: [] }],
          [{ header: 1 }, { header: 2 }],
          ['clean']
        ],
        locale: appConfig.LOCALE,
        currency: appConfig.CURRENCY !== "" ? appConfig.CURRENCY : '$'
      }
    },
    computed: {
      editionDisabled: function () {
        if (this.isAdmin) {
          return true
        }
  
        return this.product.skus.some((sku) => {
          return sku.status !== 'PENDING_APPROVAL'
        })
      },
      getSelectedDivisionId: function () {
        return this.product.division.length > 0 ? this.product.division[0].id : null
      },
      getSelectedDepartamentId: function () {
        return this.product.department.length > 0 ? this.product.department[0].departmentId : null
      },
      getSelectedClassId: function () {
        return this.product.clase.length > 0 ? this.product.clase[0].claseId : null
      }
    },
    methods: {
      selectedDivision() {
        if (this.product.division.length > 0) {
          this.$refs.departamentRef.asyncFind('')
        } else {
          this.product.department = []
          this.product.clase = []
          this.product.subClass = []
        }
      },
      selectedDepartament() {
        if (this.product.department.length > 0) {
          this.$refs.classRef.asyncFind('')
        } else {
          this.product.clase = []
          this.product.subClass = []
        }
      },
      selectedClass() {
        if (this.product.clase.length > 0) {
          this.$refs.subClassRef.asyncFind('')
        } else {
          this.product.subClass = []
        }
      },
      selectCategory (category) {
        this.loading = true
        this.errorText = ''
        this.product.category = category
        return this.getProductAtributes(category.id).then(
          (res) => {
            this.product.productSpecifications.splice(0, this.product.productSpecifications.length)
            this.specifications = res.body
            this.$emit('categorySelected', res.body)
            this.loading = false
          },
          (error) => {
            this.loading = false
            this.errorText = error.body.message || this.$t('Error obteniendo los atributos del producto')
          }
        )
      },
      _searchDivisions (text) {
        return this.searchDivisions(text)
      },
      _searchDepartaments (text) {
        return new Promise((resolve, reject) => {
          if (!this.getSelectedDivisionId) {
            resolve({ body: [] })
          } else {
            this.searchDepartaments(this.getSelectedDivisionId, text).then((res) => {
              resolve(res)
            }, (error) => {
              resolve({ body: [] })
            })
          }
        })
      },
      _searchClasses (text) {
        return new Promise((resolve, reject) => {
          if (!this.getSelectedDepartamentId) {
            resolve({ body: [] })
          } else {
            this.searchClasses(this.getSelectedDepartamentId, text).then((res) => {
              resolve(res)
            }, (error) => {
              resolve({ body: [] })
            })
          }
        })
      },
      _searchSubClasses (text) {
        return new Promise((resolve, reject) => {
          if (!this.getSelectedDepartamentId || !this.getSelectedClassId) {
            resolve({ body: [] })
          } else {
            this.searchSubClasses(this.getSelectedDepartamentId, this.getSelectedClassId, text).then((res) => {
              resolve(res)
            }, (error) => {
              resolve({ body: [] })
            })
          }
        })
      }
    }
  }
  </script>
  